import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React, { useContext, useRef } from 'react';
import { CollapseContext } from "./CollapseContext";
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import { eases } from "../../motion/eases";
import { mergePropsAndRefs } from "../../utils";
var transition = {
  ease: eases.primary,
  duration: 0.3
};
var animationVariants = {
  collapsed: {
    height: 0,
    opacity: 0,
    transition: transition
  },
  open: {
    height: 'auto',
    opacity: 1,
    transition: transition
  }
};
var childVariants = {
  collapsed: {
    y: -8,
    transition: transition
  },
  open: {
    y: 0,
    transition: transition
  }
};
export function CollapseContent(_ref) {
  var children = _ref.children,
      _ref$variants = _ref.variants,
      variants = _ref$variants === void 0 ? animationVariants : _ref$variants,
      _ref$animateOnMount = _ref.animateOnMount,
      animateOnMount = _ref$animateOnMount === void 0 ? false : _ref$animateOnMount,
      _ref$overflow = _ref.overflow,
      overflow = _ref$overflow === void 0 ? 'hidden' : _ref$overflow,
      style = _ref.style,
      other = _objectWithoutProperties(_ref, ["children", "variants", "animateOnMount", "overflow", "style"]);

  var context = useContext(CollapseContext);
  var ref = useRef(null);

  if (process.env.NODE_ENV === 'development') {
    if (!context) {
      throw new Error('CollapseContent must be used within a Collapse element.');
    }
  }

  var isShowing = context.isShowing,
      bindCollapse = context.bindCollapse,
      intentToAnimate = context.intentToAnimate;
  return /*#__PURE__*/React.createElement(AnimatePresence, {
    initial: animateOnMount
  }, isShowing && /*#__PURE__*/React.createElement(StyledContent, _extends({
    ref: ref,
    variants: variants,
    initial: "collapsed",
    animate: "open",
    exit: "collapsed"
  }, mergePropsAndRefs(bindCollapse, other), {
    style: _objectSpread(_objectSpread({}, style), {}, {
      willChange: intentToAnimate ? 'height, opacity' : 'none'
    }),
    $overflow: overflow
  }), /*#__PURE__*/React.createElement(motion.div, {
    variants: childVariants
  }, children)));
}
var StyledContent = styled(motion.div).withConfig({
  displayName: "CollapseContent__StyledContent",
  componentId: "vapor__a6r1v-0"
})(["overflow:", ";"], function (p) {
  return p.$overflow;
});
export var testExports = {
  StyledContent: StyledContent
};